import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-horizontal",
  "use": "icon-line-horizontal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-line-horizontal\"><defs><style type=\"text/css\"></style></defs><path d=\"M934.4 490.666667H81.066667a25.6 25.6 0 1 0 0 51.2h853.333333a25.6 25.6 0 1 0 0-51.2z\" p-id=\"14751\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol